<template>
  <SettingsPageFull>
    <template #title>
      <div class="flex space-x-3">
        <font-awesome-icon :icon="['fal', 'users']" size="2x" />
        <span class="text-2xl font-bold capitalize-first">
          {{ $t('navigation.content_user_title') }}
        </span>
      </div>
    </template>

    <template #cta>
      <BaseButton
        color="primary"
        icon="plus"
        @click="redirectToForm"
        :title="$t('button.add_new_m', { var: $t('global.user') })"
      />
    </template>

    <template #body>
      <BaseContentTable
        v-if="metadata.columns || loading"
        :columns="metadata.columns ?? []"
        :loading="loading"
        :modelList="userList"
        :search="true"
        @rowClick="redirectToModelPage"
        @refreshClick="withLoading(fetchAllUser())"
        @deleteModel="deleteUser"
        :isHoverable="true"
      />
    </template>
  </SettingsPageFull>
</template>

<script>
import loadingMixin from '@u/mixins/loading.mixin'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TheUserIndexPage',
  mixins: [loadingMixin],
  computed: {
    ...mapGetters({
      userList: 'user/getUserList',
      metadata: 'user/getUserMetadata'
    })
  },
  methods: {
    // ...mapActions(['fetchAllUser', 'deleteUserById','undoDeleteUserById']),
    ...mapActions({
      fetchAllUser: 'user/fetchAllUser',
      deleteUserById: 'user/deleteUserById',
      undoDeleteUserById: 'user/undoDeleteUserById'
    }),
    redirectToForm() {
      this.$router.push({ name: 'settings_create_user' })
    },
    redirectToModelPage(id) {
      this.$router.push({
        name: 'settings_edit_user_route',
        params: { id: id }
      })
    },
    deleteUser(id) {
      this.deleteUserById({
        id: id
      }).then(() => {
        this.$h.toastAction(
          'delete',
          this.$t('toasts.deleted_m', { var: this.$t('attributes.user') }),
          null,
          [
            {
              title: this.$t('button.cancel'),
              class: 'text-red-700',
              action: () => this.undoDeleteUser(id)
            }
          ]
        )
      })
    },
    undoDeleteUser(id) {
      this.undoDeleteUserById({
        id: id
      }).then(() => {
        this.$h.toastSuccess(
          this.$t('toasts.reseted_m', { var: this.$t('attributes.user') })
        )
      })
    }
  },
  mounted() {
    this.withLoading(this.fetchAllUser())
  }
}
</script>
